import { router } from "expo-router";
import { MERCH_ORDER_COPY } from "@libs/shared-ui";
import LIcon from "@components/LIcon";
import LText from "@components/LText";
import Button from "../common/Button";
import { FOUR_BUTTON_LAYOUT_BUTTON_WIDTH } from "../../config";

/** A merch product the fan has ordered: its order, as an event they hold
 *  tickets to opens My Tickets. */
const MyOrder = ({
  accessId,
  width = FOUR_BUTTON_LAYOUT_BUTTON_WIDTH,
}: {
  accessId: string;
  width?: number;
}) => (
  <Button.Button
    width={width}
    onPress={() => {
      router.push({
        pathname: "/(app)/access/[accessId]/my-order",
        params: { accessId },
      });
    }}
    sentryEventName="AccessDetail.Merch.MyOrder"
  >
    <LIcon colors={{ color: "black" }} name="merch" size={16} />
    <LText variant="Caption/C1/Medium" color="black">
      {MERCH_ORDER_COPY.open}
    </LText>
  </Button.Button>
);

export default MyOrder;
